export default "__VITE_ASSET__C1R_ts$O__"